import { Box, useMediaQuery } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Footer from "../footer/Footer";
import Navbar from "../navbar/Navbar";

export default function HomeLayout() {
  const [mobile] = useMediaQuery("(max-width: 600px)");
  return (
    <div>
      <Navbar />
      <Outlet />
      {mobile && (
        <>
          <Box h="20"></Box> <Footer />
        </>
      )}
    </div>
  );
}
